var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      !_vm.newLoading
        ? _c("div", [
            _c(
              "nav",
              {
                staticClass:
                  "navbar navbar-expand-lg navbar-dark new-navbar who-header"
              },
              [
                _c(
                  "nuxt-link",
                  {
                    staticClass: "navbar-brand who-logo",
                    attrs: { to: { name: "lang", params: { lang: _vm.lang } } }
                  },
                  [
                    _c("img", {
                      staticStyle: { width: "150px" },
                      attrs: { src: _vm.websiteLogo }
                    })
                  ]
                ),
                _c("div", { staticClass: "header-info" }, [
                  _c("h2", [
                    _vm._v(_vm._s(_vm._f("trans")("st_public.People Search")))
                  ]),
                  _c("p", [
                    _vm._v(
                      _vm._s(
                        _vm._f("trans")(
                          "st_public.Search to find information on almost anyone"
                        )
                      )
                    )
                  ])
                ])
              ],
              1
            )
          ])
        : _vm._e(),
      _c(
        "div",
        {
          staticClass: "who-layout",
          class: { "container-fluid": !_vm.newLoading }
        },
        [
          _c("nuxt", {
            on: {
              "login-logout-event": function($event) {
                return _vm.loginLogoutCheck()
              }
            }
          })
        ],
        1
      ),
      !_vm.newLoading
        ? _c("footer", { staticClass: "who-footer" }, [
            _c("div", { staticClass: "container" }, [
              _c("div", { staticClass: "text-center" }, [
                _c("div", { staticClass: "bottom-footer" }, [
                  _c("div", { staticClass: "copyright" }, [
                    _vm._v(
                      "\n                        " +
                        _vm._s(
                          _vm._f("trans")("st_public.All Rights Reserved")
                        ) +
                        " "
                    ),
                    _c("a", { attrs: { href: "" } }, [
                      _vm._v(_vm._s(_vm.websiteName()))
                    ])
                  ])
                ])
              ])
            ])
          ])
        : _vm._e(),
      _c("flash"),
      _c("div", { attrs: { id: "trackingCodes" } }),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.loading,
              expression: "loading"
            }
          ],
          staticClass: "loading-page text-center text-success"
        },
        [
          _c("div", {}, [
            _vm._v(_vm._s(_vm._f("trans")("st_public.please_wait")))
          ]),
          _c("div", {
            staticClass: "fa fa-cog fa-spin",
            staticStyle: { "font-size": "50px" }
          })
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-06cc8242", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-06cc8242","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./layouts/green.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-06cc8242","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./layouts/green.vue
// module chunks = 17